module.exports = __webpack_public_path__ + "img/8_big.d2895b41.png";